/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/12
 */
import React from 'react';

const RightArrow = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-rightarrow">
    <path d="M297.63 995.996c-6.43 0-19.276 0-25.698-6.43-12.849-12.849-12.849-32.125 0-44.981l424.097-424.097-417.677-436.961c-12.849-12.849-12.849-32.125 0-44.981s32.125-12.849 44.981 0l449.808 449.808c6.43 6.43 6.43 12.849 6.43 25.698s0 19.276-6.43 19.276l-449.808 449.808c-6.43 6.43-12.849 12.849-25.698 12.849z"/>
  </svg>
};

export default RightArrow;



// WEBPACK FOOTER //
// ./src/svgs/rightArrow.js